<template>
    <div>
        <h3 class="font-bold text-xl mb-4">{{ $t("verifyYourPhone") }}</h3>
        <div v-if="!codeResent">
        <p class="mb-3">
            {{ $t("authCodeSent", [mobilePhone]) }}
        </p>
        <p>
            {{ $t("didntGetCode") }}
            <a class="text-primary-500 hover:text-primary-600" @click="resendCode">
                {{ $t("resendVerificationCode") }}
            </a>

        </p>
        </div>
        <div v-if="codeResent">
            <p class="mb-3">
                {{ $t("authCodeResent", [mobilePhone]) }}
            </p>
        </div>

        <div class="mt-3">
            <k-input
                    class="mb-4"
                    id="verificationCode"
                    label="Verification code"
                    v-model="form.verificationCode"
                    :field-errors="validation.fieldErrors"/>

            <k-button @click.native.prevent="verifyCode">
                {{ $t("verify") }}
            </k-button>
        </div>
        <div class="mt-5 text-gray-500 text-sm" v-if="verificationCode">
            {{verificationCode}}
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                verificationCode: null,
                mobilePhone: null,
                codeResent: false,
                form: {
                    verificationCode: null
                },
                validation: {
                    fieldErrors: {}
                }
            }
        },
        async mounted() {
            await this.sendCode();
        },
        methods: {
            async resendCode() {
              await this.sendCode();
              this.codeResent = true;
            },
            async sendCode() {
                const resp = await this.$post('registration/send-verification-sms')
                this.mobilePhone = resp.mobilePhone;
                // for testing only, on production will be empty
                this.verificationCode = resp.verificationCode;
            },
            async verifyCode() {
                this.validation = {
                    fieldErrors: {}
                };
                try {
                    await this.$post('registration/verify-phone', this.form);
                    await this.$fetchInvestorProfile();
                    await this.$routeInvestor();
                } catch (error) {
                    if (error.response && error.response.status === 400) {
                        this.validation = error.response.data;
                        this.$scrollToErrorField();
                    }
                }
            },
            fieldError(field) {
                return this.validation.fieldErrors[field];
            },
        }
    }
</script>

